/**
 * shared Zod preprocessor utilities
 * converts various input types to the expected format for validation
 */

/**
 * converts empty strings, null, or undefined to null; otherwise parses as number
 * used for nullable numeric fields where empty input should be treated as null (ie. backspacing a field to clear it)
 */
export const preprocessNullableNumber = (val: unknown): number | null => {
  if (val === "" || val === null || val === undefined) return null;
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    const parsed = parseFloat(val);
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};

/**
 * converts empty strings, null, or undefined to null; otherwise parses as integer
 * used for nullable integer fields where empty input should be treated as null (ie. backspacing a field to clear it)
 */
export const preprocessNullableInteger = (val: unknown): number | null => {
  if (val === "" || val === null || val === undefined) return null;
  if (typeof val === "number") return Math.floor(val);
  if (typeof val === "string") {
    const parsed = parseInt(val, 10);
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};

/**
 * converts empty strings to empty string; null/undefined to null
 * used for optional string fields
 */
export const preprocessOptionalString = (val: unknown): string | null => {
  if (val === null || val === undefined) return null;
  if (typeof val === "string") return val.trim();
  return String(val);
};
